module.exports = __webpack_public_path__ + "open-sans-v20-latin-600.woff2";